export const successionKeyJobSelector = state => state.successionKeyJob;
